'use strict';

function applyUserOptions(target) {
  /**
   * @prop {string} [user.email]
   * User email.
   */
  target['user.email'] = undefined;

  /**
   * @prop {string} [user.type]
   * User type.
   */
  target['user.type'] = undefined;

  /**
   * @prop {string} [user.name]
   * User ID value inside your system.
   */
  target['user.name'] = undefined;

  /**
   *  @prop {boolean} [user.obfuscateIp=false]
   * If true, the view will have the IP obfuscated
   */
  target['user.obfuscateIp'] = false;

  /**
   * @prop {string} [user.anonymousId]
   * Anonymous identifier of the user provided by the customer.
   */
  target['user.anonymousId'] = undefined;

  /**
   * @prop {string} [__managedAnonymousUserId]
   * Internal. Managed anonymous device id set by Product Analytics when manageAnonymousUsers
   * is enabled; used only as the username fallback. Not customer-facing.
   */
  target['__managedAnonymousUserId'] = undefined;

  /**
   * @prop {string} [user.privacyProtocol]
   * Privacy protocol to be used, nothing by default.
   * Possible values are "optin" and "optout"
   */
  target['user.privacyProtocol'] = undefined;
}

module.exports = applyUserOptions;

